import { api } from 'app/config/apiConfig';
import { Lead } from '../model/types';

export const getLeadByUserIdApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLeadByUserId: builder.query<Lead, string | undefined>({
      query: (userId) => ({
        url: `/leads/${userId}`,
      }),
    }),
  }),
});

export const { useGetLeadByUserIdQuery } = getLeadByUserIdApi;
